/**
 * 会员营销 - 会员分群
 */

import {get, post, postJson, deleteApi,imagePost} from '../axios'

// const RESOURCE_BASE_PATH = '/jd-yusms/memberCrowd'
const RESOURCE_BASE_PATH = '/memberCrowd/'

// 查询会员人群
export const queryMemberCrowd = p => get(`${RESOURCE_BASE_PATH}`, p);

// 新增/编辑会员人群
export const addMemberCrowd = p => postJson(`${RESOURCE_BASE_PATH}`, p);

// 查询商家创建的人群总数
export const createdCount = p => get(`${RESOURCE_BASE_PATH}created-count`, p);

// 人群实例化
export const crowdInstance = p => postJson(`${RESOURCE_BASE_PATH}crowd-instance`, p);

// 人群包状态更新
export const packStatus = p => postJson(`${RESOURCE_BASE_PATH}pack-status`, p);
// 人群包状态更新

// 删除人群
export const delMemberCrowd = (precisionCrowdStrategyId, strategyId) => deleteApi(`${RESOURCE_BASE_PATH}${precisionCrowdStrategyId}`, {strategyId});

// 同步数坊人群
export const isvUsrPack = p => postJson(`${RESOURCE_BASE_PATH}isv-user-pack`, p);

// 人群分析
export const crowdAnalysis = p => postJson(`${RESOURCE_BASE_PATH}crowd-analysis`, p);
// 上传人群-手动输入
export const uploadManual = p => postJson(`${RESOURCE_BASE_PATH}upload-manual`, p);

// 上传人群-文件导入
export const uploadImport = p => imagePost(`${RESOURCE_BASE_PATH}upload-import`, p);

// 将人群同步至DMP
export const synDmp = p => postJson(`${RESOURCE_BASE_PATH}syn-dmp`, p);

// 获取官方推荐列表
export const getOfficialRecommend = p => get(`${RESOURCE_BASE_PATH}official/recommend`, p)

// 官方推荐人群立即营销
export const officialMarket = p => postJson(`${RESOURCE_BASE_PATH}official/marketing`, p)